<template>
  <div class="mt-2">
    <form data-vv-scope="comment-management">
      <div v-if="action === 'resend'">
        <resend-approval
          v-model="resendSubject"
          :officeType="stepOffice"
        />
        <div
          v-if="error.message !== ''"
          class="con-text-validation span-text-validation-danger
          vs-input--text-validation-span v-enter-to text-right"
          style="height: 32px;"
        >
        <span class="span-text-validation">
          {{error.message}}
        </span>
        </div>
      </div>
      <vs-textarea
        class="mb-2"
        maxlength="1000"
        counter="1000"
        label="Comentario"
        v-model="comment"
        name="comment"
        v-validate="{required: action === 'reject', min: 5}"
      />
      <div v-if="errors.first('comment-management.comment')"
           class="con-text-validation span-text-validation-danger
           vs-input--text-validation-span v-enter-to"
           style="height: 20px;">
          <span class="span-text-validation">
            {{errors.first('comment-management.comment')}}
          </span>
      </div>
    </form>
    <div class="my-5 text-right" v-if="enableAttachButton">
      <UploadFile
        permission="*"
        text="Agregar"
        v-model="file"
        :upload-to="urlFile"
        type-button="small"
        button-class=""
        container-class="text-right"
        @input="addAdditionalFile()"
      />
    </div>
    <div class="row">
      <div class="col-2" v-for="file in commentFiles" :key="file.id">
        <div class="d-flex flex-column align-items-center">
          <vs-icon icon="description" size="30px" color="primary" />
          <b class="text-truncate w-100 text-center">
            {{ file.name }}
          </b>
          <vs-button
            color="danger"
            type="flat"
            icon="clear"
            @click="removeAdditionalFile(file.id)"
          />
        </div>
      </div>
    </div>
    <div class="text-right mt-4">
      <b-button
        variant="primary"
        @click="sendAction()"
      >
        Reenviar
      </b-button>
    </div>
  </div>
</template>
<script>

import { mapActions, mapGetters } from 'vuex';
import {
  VBToggle,
  VBModal
} from 'bootstrap-vue';
import Ripple from 'vue-ripple-directive';

import UploadFile from '@/febos/global/_vue/componentes/UploadFile';
import { stepTypesCode } from '@/febos/chile/approvals/components/trays/managementTray/constants';
import ResendApproval from '@/febos/chile/approvals/components/trays/managementTray/modals/ResendApproval';
import StepTypes from '@/febos/chile/dnt/mixins/StepTypes';

export default {
  components: {
    UploadFile,
    ResendApproval
  },
  data() {
    return {
      error: {
        message: ''
      },
      comment: '',
      file: {},
      commentFiles: [],
      resendSubject: {
        type: stepTypesCode.usuario,
        continueFlow: true
      }
    };
  },
  computed: {
    ...mapGetters('Empresas', [
      'groupsCompany',
      'company'
    ]),
    enableAttachButton() {
      return !this.isSiss;
    },
    isSiss() {
      return this.company.iut === '61221000-4';
    },
    stepOffice() {
      const office = this.groupsCompany
        .find((group) => group.id === this.stepId.paso.tipoValorResponsableId);

      let officeType;

      if (!office) {
        officeType = StepTypes.INTERNAL_OFFICES;
      } else {
        officeType = office.tipo === 'ext' ? StepTypes.EXTERNAL_OFFICES : StepTypes.INTERNAL_OFFICES;
      }

      return { type: !office ? 'int' : office.tipo, codeType: officeType };
    },
    urlFile() {
      return `febos-io/global/${process.env.VUE_APP_AMBIENTE}/empresas/aprobaciones/${this.flowId}/comentarios`;
    }
  },
  methods: {
    ...mapActions('Approvals', [
      'commentFileFlow',
      'processFileFlow'
    ]),
    cancelProcess() {},
    async validateForm(scope) {
      const result = await this.$validator.validateAll(scope);
      return !!result;
    },
    makeObjectRequest() {
      const request = {
        idEjecucion: this.flowId,
        idAprobacion: this.fileId,
        pasoId: this.stepId.id
      };

      const actions = {
        approve: 'aprobar',
        reject: 'rechazar',
        return: 'devolver',
        comment: 'comentario',
        resend: 'reenviar'
      };

      const body = {
        comentario: {
          accion: actions[this.action],
          comentario: this.comment
        },
        documentos: this.commentFiles && this.commentFiles.map((file) => ({
          tipo: actions[this.action],
          nombre: file.name,
          adjuntoId: file.id,
          adjuntoUrl: file.path,
          adjuntoMime: file.mime,
          adjuntoEstado: 2
        }))
      };
      body.estado = actions[this.action].toUpperCase();
      body.temporalUsuario = this.resendSubject.name || '';
      body.temporalUsuarioId = this.resendSubject.id || '';
      body.temporalContinuar = this.resendSubject.continueFlow || false;
      body.tipoPaso = this.resendSubject.type;

      return { request, body };
    },
    async sendAction() {
      if (!this.resendSubject.id || this.resendSubject.id === '') {
        this.error.message = 'Oops! Debes seleccionar un usuario/grupo para poder reenviar';
        return;
      }
      this.error.message = '';
      const isValid = await this.validateForm('comment-management');
      if (!isValid) {
        return;
      }

      const response = await this.processFileFlow(this.makeObjectRequest());
      this.$bvToast.toast(
        `${response.mensaje}`,
        {
          title: '¡Genial!',
          variant: 'primary',
          pauseOnHover: true,
          solid: true,
          noAutoHide: true
        }
      );
      this.$emit('close');
    },
    async addAdditionalFile() {
      if (!Object.keys(this.file).length) {
        return;
      }

      if (this.file.failed) {
        // TODO: display error message.
        this.error.message = 'La carga del archivo falló, inténtalo de nuevo';
        return;
      }

      const alreadyExists = this.commentFiles.some((f) => f.id === this.file.id);
      if (!alreadyExists) {
        this.commentFiles.push(this.file);
      }
      await this.$validator.reset();
    },
    removeAdditionalFile(fileId) {
      this.commentFiles = this.commentFiles.filter((file) => file.id !== fileId);
    }
  },
  props: {
    action: { type: String, required: true },
    stepId: { type: Object, required: false },
    fileId: { type: String, required: true },
    flowId: { type: String, required: true }
  },
  directives: {
    'b-toggle': VBToggle,
    Ripple,
    'b-modal': VBModal
  },
};
</script>
